import { render, staticRenderFns } from "./TeamTag.vue?vue&type=template&id=03ed4df1&scoped=true&"
import script from "./TeamTag.vue?vue&type=script&lang=js&"
export * from "./TeamTag.vue?vue&type=script&lang=js&"
import style0 from "./TeamTag.vue?vue&type=style&index=0&id=03ed4df1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ed4df1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03ed4df1')) {
      api.createRecord('03ed4df1', component.options)
    } else {
      api.reload('03ed4df1', component.options)
    }
    module.hot.accept("./TeamTag.vue?vue&type=template&id=03ed4df1&scoped=true&", function () {
      api.rerender('03ed4df1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/TeamTag.vue"
export default component.exports